  <div id="enterprise-aml-report">
    <PageControl :title="'Enterprise Anti-Money Laundering Report'" :elements_query="sheet_elements">
      <button v-if="total_matches > 0" @click="show_export_modal"
        class="btn btn-bg-green text-xs rounded-small shadow-sm me-2">
        <i class="bi bi-download"></i>
        Export Data
      </button>

      <!-- Export Modal -->
      <Teleport to="body">
        <div v-if="total_matches > 0" class="modal fade" :id="'export-modal-' + application_id" tabindex="-1"
          aria-labelledby="exportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content rounded-4 shadow">
            <div class="modal-header">
              <h6 class="modal-title fw-semibold text-muted">
                Export Enterprise AML Report Data
              </h6>
              <button type="button" class="btn-close" @click="close_modal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label fw-bold">Select Data to Export:</label>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="export_options.subject_info"
                    id="subjectInfo" />
                  <label class="form-check-label" for="subjectInfo">
                    Subject Information ({{ total_matches > 0 ? '1' : '0' }} record)
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="export_options.negative_media"
                    id="negativeMedia" />
                  <label class="form-check-label" for="negativeMedia">
                    Negative Media Results ({{ nm_count }} matches)
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="export_options.watchlist" id="watchlist" />
                  <label class="form-check-label" for="watchlist">
                    Watchlist Results ({{ wls_count }} matches)
                  </label>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold">Export Format:</label>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="exportFormat" value="csv" v-model="export_format"
                    id="csvFormat" />
                  <label class="form-check-label" for="csvFormat">
                    CSV (Comma Separated Values)
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="exportFormat" value="excel" v-model="export_format"
                    id="excelFormat" />
                  <label class="form-check-label" for="excelFormat">
                    Excel (.xlsx)
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="exportFormat" value="json" v-model="export_format"
                    id="jsonFormat" />
                  <label class="form-check-label" for="jsonFormat">
                    JSON (JavaScript Object Notation)
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-bg-secondary text-xs rounded-small" @click="close_modal">
                Cancel
              </button>
              <button type="button" class="btn btn-bg-green text-xs rounded-small" @click="export_data" :disabled="!has_selected_tables">
                Export Data
              </button>
            </div>
          </div>
        </div>
      </div>
      </Teleport>
    </PageControl>

    <PageComponent>
      <SectionSheet>
        <div class="container-fluid py-3 header d-flex align-items-center justify-content-between border-bottom mb-3">
          <div class="d-flex">
            <img class="logo" width="295" height="125" src="@/assets/images/new_black_logo2.svg" alt="Logo" />
          </div>
          <div class="d-flex text-end">
            <div>
              <div class="h4 fw-bold mb-1">Enterprise AML Verification</div>
              <div class="text-muted text-xs">
                28 Fricker Rd,<br />
                Illovo, Johannesburg,<br />
                2196 South Africa<br />
                Website:
                <a href="https://www.goodpeopledata.com/" target="_blank"
                  class="text-decoration-none text-muted">www.goodpeopledata.com</a>
              </div>
            </div>
          </div>
        </div>

        <div v-if="total_matches > 0">
          <div class="card shadow-sm border bg-white mb-2">
            <div class="card-header">
              <h6 class="mb-0">
                Enterprise Anti-Money Laundering Verification Summary
              </h6>
            </div>
            <div class="card-body text-xs">
              <p class="mb-3">
                This <strong>Enterprise AML Verification</strong> was performed on
                <strong>{{ source_match }}</strong> for Application ID
                <strong>{{ application_id }}</strong>. The subject was thoroughly screened against
                multiple watchlists and negative media sources to ensure
                compliance.
                <br />
                <br />
                The enterprise AML report decision is based on the results of the
                watchlist and negative media checks. The decision is stated as
                follows:
              </p>

              <div class="d-flex justify-content-center mb-3">
                <div class="col-sm-12 text-center">
                  <span class="fw-bold text-xs text-muted">Enterprise AML Status:
                  </span>
                  <strong :class="verification_status_icon_class">{{
                    watchlist_decision
                    }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="card shadow-sm border bg-white mb-2">
            <div class="card-header">
              <h6 class="mb-0">
                Enterprise Anti-Money Laundering Verification Summary
              </h6>
            </div>
            <div class="card-body text-xs">
              <p class="mb-3">
                This <strong>Enterprise AML Verification</strong> was performed for
                <strong>{{ source_match || "the subject" }}</strong> for Application ID
                <strong>{{ application_id }}</strong>. The subject was thoroughly screened against
                multiple databases to ensure compliance.
              </p>

              <div class="text-center py-3">
                <div class="alert alert-success mb-0">
                  <i class="fas fa-check-circle fa-3x text-success mb-3"></i>
                  <h5 class="text-success">No Matches Found</h5>
                  <p class="mb-0">
                    No matches were found in any of the screened databases. All
                    checks completed successfully with clean results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Subject Information -->
        <div>
          <div class="card shadow-sm border bg-white mb-2">
            <div class="card-header">
              <h6 class="mb-0">Subject Information</h6>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-sm-6">
                  <strong class="text-muted small">Subject Name:</strong>
                  <div class="fw-bold">{{ source_match }}</div>
                </div>
                <div class="col-sm-6">
                  <strong class="text-muted small">Verification Date:</strong>
                  <div class="fw-bold">{{ date_scored_formatted }}</div>
                </div>
                <div class="col-sm-6">
                  <strong class="text-muted small">Application ID:</strong>
                  <div class="fw-bold">{{ application_id }}</div>
                </div>
                <div class="col-sm-6">
                  <strong class="text-muted small">Risk Decision:</strong>
                  <div class="fw-bold" :class="verification_status_icon_class">{{ watchlist_decision }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="report-meta">
          <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
          <div>
            <span class="text-muted">Generated:</span> {{ generated_date }}
          </div>
        </div>
      </SectionSheet>

      <!-- Negative Media Results -->
      <template v-if="nm_results && nm_results.length > 0">
        <template v-for="(chunk, chunk_index) in nm_result_chunks" :key="`nm-result-${chunk_index}`">
          <SectionSheet>
            <div class="card shadow-sm border mb-4" v-if="chunk_index === 0">
              <div class="card-header">
                <h6 class="mb-0">Negative Media Results</h6>
              </div>
              <div class="card-body p-3">
                <p class="text-muted ms-2 text-xs">
                  {{ nm_count }} match{{ nm_count !== 1 ? 'es' : '' }} found in negative media databases indicating
                  potential adverse publicity.
                </p>
              </div>
            </div>
            <!-- Individual Results -->
            <div v-for="(result, index) in chunk" :key="index"
              class="card nm-card border-left-accent shadow-sm border mb-1">
              <div class="card-body p-0">
                <!-- Header section with badges -->
                <div class="nm-card-header p-2">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div class="nm-title-section flex-grow-1">
                      <h6 class="nm-article-title mb-1">
                        <i class="bi bi-newspaper text-muted me-2"></i>
                        {{ result.articleTitle || result.text?.substring(0, 60) + "..." }}
                      </h6>
                      <div class="nm-subject-info">
                        <span class="text-muted small">Subject:</span>
                        <span class="fw-semibold text-dark ms-1">{{ result.subjectMatched }}</span>
                      </div>
                    </div>
                    <div class="nm-score-badge">
                      <span class="badge nm-score-badge-custom">
                        Score: <span class="fw-bold text-white">{{ (result.score).toFixed(2) }}</span>
                      </span>
                    </div>
                  </div>

                  <div class="nm-meta-badges">
                    <span class="badge nm-category-badge">
                      <i class="bi bi-tag-fill me-1"></i>{{ result.category }}
                    </span>
                    <span v-if="result.articleDate" class="badge nm-date-badge">
                      <i class="bi bi-calendar3 me-1"></i>{{ formatDate(result.articleDate) }}
                    </span>
                    <span v-if="result.sourceCountry" class="badge nm-country-badge">
                      <i class="bi bi-geo-alt-fill me-1"></i>{{ result.sourceCountry }}
                    </span>
                  </div>
                </div>

                <!-- Content section -->
                <div class="nm-card-content px-3">
                  <div class="nm-text-content">
                    <p class="text-muted mb-3 lh-base">{{ result.text }}</p>
                  </div>

                  <!-- Highlights section -->
                  <div v-if="result.highlights && result.highlights.length" class="nm-highlights mb-3">
                    <div class="nm-highlights-header mb-2">
                      <i class="bi bi-lightbulb text-warning me-2"></i>
                      <span class="fw-semibold text-dark small">Key Highlights</span>
                    </div>
                    <div class="nm-highlights-content">
                      <div v-html="format_highlights(result.highlights)"></div>
                    </div>
                  </div>

                  <!-- Concepts section -->
                  <div v-if="result.concepts && result.concepts.length" class="nm-concepts mb-1">
                    <div class="nm-concepts-header mb-1">
                      <i class="bi bi-tags text-info me-2"></i>
                      <span class="fw-semibold text-dark small">Related Concepts</span>
                    </div>
                    <div class="nm-concepts-list">
                      <span v-for="(concept, idx) in result.concepts" :key="idx" class="badge nm-concept-tag me-1 mb-1">
                        {{ concept }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Footer section with URL -->
                <div v-if="result.url" class="nm-card-footer px-3 py-2">
                  <div class="nm-url-section">
                    <i class="bi bi-link-45deg text-primary me-2"></i>
                    <a :href="result.url" target="_blank" class="nm-source-link">
                      {{ result.url }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="report-meta">
              <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
              <div>
                <span class="text-muted">Generated:</span> {{ generated_date }}
              </div>
            </div>
          </SectionSheet>
        </template>
      </template>

      <template v-if="!nm_results || nm_results.length === 0">
        <SectionSheet>
          <div class="card shadow-sm border bg-white mb-4">
            <div class="card-header">
              <h6 class="mb-0">Negative Media Results</h6>
            </div>
            <div class="card-body text-center py-4">
              <div class="alert alert-info mb-0">
                <i class="fas fa-info-circle fa-2x text-info mb-3"></i>
                <h6 class="text-info">No Negative Media Records Found</h6>
                <p class="mb-0">
                  No adverse media coverage or negative publicity was found for
                  <strong>{{ source_match || "the subject" }}</strong> in
                  our comprehensive negative media databases.
                </p>
              </div>
            </div>
          </div>

          <div class="report-meta">
            <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
            <div>
              <span class="text-muted">Generated:</span> {{ generated_date }}
            </div>
          </div>
        </SectionSheet>
      </template>

      <!-- Negative Media Results exceed limit message -->
      <template v-if="nm_exceeds_limit && nm_results && nm_results.length > 0">
        <SectionSheet>
          <div class="limit-exceeded-notice">
            <div class="limit-card nm-limit shadow-sm border mb-4">
              <div class="limit-header">
                <div class="limit-icon">
                  <i class="bi bi-newspaper text-white"></i>
                </div>
                <div class="limit-title flex-grow-1">
                  <h6>Negative Media Results Limited</h6>
                  <div class="limit-subtitle">Display limit reached for report readability</div>
                </div>
              </div>
              <div class="limit-content">
                <div class="limit-stats">
                  <div class="stat-item">
                    <div class="stat-label">Displayed</div>
                    <div class="stat-value">{{ limited_nm_results.length }}</div>
                  </div>
                  <div class="stat-divider">of</div>
                  <div class="stat-item">
                    <div class="stat-label">Total Found</div>
                    <div class="stat-value">{{ nm_count }}</div>
                  </div>
                </div>
                <div class="limit-message">
                  <i class="bi bi-info-circle"></i>
                  <span>Only the first {{ limited_nm_results.length }} results are shown above to maintain report
                    readability.</span>
                </div>
                <div class="limit-action">
                  <i class="bi bi-download"></i>
                  <span>Use the export function to access all {{ nm_count }} negative media results in your preferred
                    format (CSV, Excel, or JSON).</span>
                </div>
              </div>
            </div>
          </div>

          <div class="report-meta">
            <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
            <div>
              <span class="text-muted">Generated:</span> {{ generated_date }}
            </div>
          </div>
        </SectionSheet>
      </template>

      <!-- Watchlist Results -->
      <template v-if="wls_results && wls_results.length > 0">
        <template v-for="(chunk, chunk_index) in wls_result_chunks" :key="`wls-result-${chunk_index}`">
          <SectionSheet>
            <div class="card shadow-sm border mb-4" v-if="chunk_index === 0">
              <div class="card-header">
                <h6 class="mb-0">Watchlist Results</h6>
              </div>
              <div class="card-body p-3">
                <p class="text-muted ms-2 text-xs">
                  {{ wls_count }} match{{ wls_count !== 1 ? 'es' : '' }} found in watchlist databases indicating
                  potential sanctions or restrictions.
                </p>
              </div>
            </div>
            <!-- Individual Results -->
            <div v-for="(result, index) in chunk" :key="index"
              class="card wls-card border-left-accent shadow-sm border mb-1">
              <div class="card-body p-0">
                <!-- Header section with badges -->
                <div class="wls-card-header p-2">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div class="wls-title-section flex-grow-1">
                      <h6 class="wls-alert-title mb-1">
                        <i class="bi bi-shield-exclamation text-muted me-2"></i>
                        Watchlist Match Alert
                      </h6>
                      <div class="wls-subject-info">
                        <span class="text-muted small">Subject:</span>
                        <span class="fw-semibold text-dark ms-1">{{ result.subjectMatched }}</span>
                      </div>
                    </div>
                    <div class="wls-score-badge">
                      <span class="badge wls-score-badge-custom">
                        Score: <span class="fw-bold text-white">{{ (result.score).toFixed(2) }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="wls-meta-badges">
                    <span v-for="(cat, idx) in result.category?.split(',')" :key="idx" class="badge wls-category-badge">
                      <i class="bi bi-exclamation-triangle-fill me-1"></i>{{ cat?.trim() }}
                    </span>
                    <span v-if="result.sourceAgencyName" class="badge wls-agency-badge">
                      <i class="bi bi-building me-1"></i>{{ result.sourceAgencyName }}
                    </span>
                    <span v-if="result.sourceListType" class="badge wls-list-badge">
                      <i class="bi bi-list-ul me-1"></i>{{ result.sourceListType }}
                    </span>
                    <span v-if="result.sourceRegion || result.sourceCountry" class="badge wls-region-badge">
                      <i class="bi bi-geo-alt-fill me-1"></i>{{ result.sourceRegion || result.sourceCountry }}
                    </span>
                  </div>
                </div>

                <!-- Content section -->
                <div class="wls-card-content px-3 pb-2">
                  <div class="wls-text-content">
                    <p class="text-muted mb-3 lh-base">{{ result.text }}</p>
                  </div>

                  <!-- Highlights section -->
                  <div v-if="result.highlights && result.highlights.length" class="wls-highlights mb-3">
                    <div class="wls-highlights-header mb-2">
                      <i class="bi bi-lightbulb text-warning me-2"></i>
                      <span class="fw-semibold text-dark small">Key Highlights</span>
                    </div>
                    <div class="wls-highlights-content">
                      <div v-html="format_highlights(result.highlights)"></div>
                    </div>
                  </div>

                  <!-- Remarks section -->
                  <div v-if="result.remarks" class="wls-remarks mb-1">
                    <div class="wls-remarks-header mb-1">
                      <i class="bi bi-info-circle text-info me-2"></i>
                      <span class="fw-semibold text-dark small">Additional Information</span>
                    </div>
                    <div class="wls-remarks-content">
                      <p class="mb-0 text-muted">{{ result.remarks }}</p>
                    </div>
                  </div>
                </div>

                <!-- Footer section with URL -->
                <div v-if="result.url" class="wls-card-footer px-3 py-2">
                  <div class="wls-url-section">
                    <i class="bi bi-link-45deg text-primary me-2"></i>
                    <a :href="result.url" target="_blank" class="wls-source-link">
                      {{ result.url }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="report-meta">
              <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
              <div>
                <span class="text-muted">Generated:</span> {{ generated_date }}
              </div>
            </div>
          </SectionSheet>
        </template>
      </template>

      <!-- Watchlist Results - NO Data Available -->
      <template v-if="!wls_results || wls_results.length === 0">
        <SectionSheet>
          <div class="card shadow-sm border bg-white mb-4">
            <div class="card-header">
              <h6 class="mb-0">Watchlist Results</h6>
            </div>
            <div class="card-body text-center py-4">
              <div class="alert alert-info mb-0">
                <i class="fas fa-shield-alt fa-2x text-info mb-3"></i>
                <h6 class="text-info">No Watchlist Records Found</h6>
                <p class="mb-0">
                  <strong>{{ source_match || "The subject" }}</strong> was
                  not found on any local or international watchlists or
                  sanctions databases, including but not limited to the OFAC
                  (Office of Foreign Assets Control), United Nations Security
                  Council (UNSC) sanctions lists, or any applicable Targeted
                  Financial Sanctions (TFS) lists.
                </p>
              </div>
            </div>
          </div>

          <div class="report-meta">
            <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
            <div>
              <span class="text-muted">Generated:</span> {{ generated_date }}
            </div>
          </div>
        </SectionSheet>
      </template>

      <!-- Watchlist Results exceed limit message -->
      <template v-if="wls_exceeds_limit && wls_results && wls_results.length > 0">
        <SectionSheet>
          <div class="limit-exceeded-notice">
            <div class="limit-card watchlist-limit shadow-sm border mb-4">
              <div class="limit-header">
                <div class="limit-icon">
                  <i class="bi bi-shield-exclamation"></i>
                </div>
                <div class="limit-title flex-grow-1">
                  <h6>Watchlist Results Limited</h6>
                  <div class="limit-subtitle">Display limit reached for report readability</div>
                </div>
              </div>
              <div class="limit-content">
                <div class="limit-stats">
                  <div class="stat-item">
                    <div class="stat-label">Displayed</div>
                    <div class="stat-value">{{ limited_wls_results.length }}</div>
                  </div>
                  <div class="stat-divider">of</div>
                  <div class="stat-item">
                    <div class="stat-label">Total Found</div>
                    <div class="stat-value">{{ wls_count }}</div>
                  </div>
                </div>
                <div class="limit-message">
                  <i class="bi bi-info-circle"></i>
                  <span>Only the first {{ limited_wls_results.length }} results are shown above to maintain report
                    readability.</span>
                </div>
                <div class="limit-action">
                  <i class="bi bi-download"></i>
                  <span>Use the export function to access all {{ wls_count }} watchlist results in your preferred format
                    (CSV, Excel, or JSON).</span>
                </div>
              </div>
            </div>
          </div>

          <div class="report-meta">
            <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
            <div>
              <span class="text-muted">Generated:</span> {{ generated_date }}
            </div>
          </div>
        </SectionSheet>
      </template>

      <SectionSheet>
        <div class="card shadow-sm border bg-white mb-4 p-2">
          <div class="card-header bg-light">
            <h6 class="mb-0">Disclaimer and Information</h6>
          </div>
          <div class="card-body">
            <div class="disclaimer-content">
              <h6 class="mb-3 border-bottom pb-2">
                <i class="bi bi-info-circle me-2"></i>General Information
              </h6>
              <p class="text-xs mb-4">
                This Enterprise Anti-Money Laundering Verification Report
                provides a comprehensive assessment of potential risks
                associated with the subject. The verification process screens
                the subject against multiple watchlists and negative media
                sources to identify potential matches that may indicate money
                laundering, sanctions violations, or other financial crimes.
              </p>

              <h6 class="mb-3 border-bottom pb-2">
                <i class="bi bi-shield-lock me-2"></i>Data Sources and
                Limitations
              </h6>
              <p class="text-xs mb-4">
                This report contains data provided by external sources that has
                not been modified or changed in any way by THE GOOD PEOPLE DATA
                COMPANY (PTY) LTD. The accuracy, completeness, and timeliness of
                the information is dependent on these external sources used.
                This screening service utilizes fuzzy search technology that may
                produce inaccurate results and/or false positives. All potential
                matches require thorough human review and verification.
              </p>

              <h6 class="mb-3 border-bottom pb-2">
                <i class="bi bi-gear me-2"></i>Technical Notes
              </h6>
              <p class="text-xs mb-4">
                Verification scores and risk assessments are calculated using
                proprietary algorithms that measure the likelihood of true
                matches against watchlists and negative media sources.
                Environmental factors such as name variations, transliterations,
                and data quality may impact verification results and should be
                considered during review.
              </p>

              <div class="text-center text-muted mt-3">
                <p class="mb-0 text-xs">
                  © {{ new Date().getFullYear() }} The Good People Data Company.
                  All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="report-meta">
          <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
          <div>
            <span class="text-muted">Generated:</span> {{ generated_date }}
          </div>
        </div>
      </SectionSheet>
    </PageComponent>
  </div>